<template>
    <div>
        <div class="supplementBox">
            <div class="supplement">
                <h4>补充证据</h4>
                <p style="border: 1px solid #3b63f6"></p>
            </div>
            <div class="contractNameBox">
                <div class="contractName">
                    <p>合同名称:</p>
                    <el-input v-model="designation"  placeholder="请输入合同名称"></el-input>
                </div>
                <div class="contractType">
                    <p>合同类型:</p>
                    <el-input v-model="genre"  placeholder="请输入合同类型"></el-input>
                </div>
                <el-button  class="particulars">合同详情</el-button>
            </div>
            <div class="evidenceBox">
                <div class="evidence">
                    <p>车辆证据</p>
                </div>
                <div class="proofBox">
                    <div v-for="(item,index) in 2" :key="index">
                    <el-form>
                    <el-form-item label="信用卡申请表(卡分期专用)" class="inline-2">
                        <el-input v-model="filename[index]" class="input-320" placeholder="仅支持.jpg、.png、.pdf文件" :disabled="edit"></el-input>
                        <el-upload
                                class="inline"
                                :show-file-list="false"
                                :limit="3"
                                accept=".pdf,.jpg,.png"
                                action=""
                                :on-change="handleChange"
                                multiple
                                :file-list="fileData"
                                >
                            上传
<!--                            <el-button type="primary" style="margin-left: 5px" size="mini" title="上传文件"><i class="iconfont iconwenjian"></i></el-button>-->
                        </el-upload>
                        <el-button  class="View" @click="View">查看</el-button>
                    </el-form-item>
                    </el-form>
                    </div>


<!--                    查看弹框-->
                    <el-dialog
                            title="提示"
                            :visible.sync="dialogVisible"
                            width="30%"
                            :before-close="handleClose">
                        <span>这是一段信息</span>
                        <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                        </span>
                    </el-dialog>
                </div>

            </div>
            <div class="save" style="margin: auto;">
                <el-button  class="save">保存证据</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "supplement",
        data(){
            return{
                dialogVisible: false,
                edit:true,
                fileData:[],
                newArr: [],
                designation:'', //合同名称
                genre:'', //合同类型
                filename:[],
            }
        },
        methods: {
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            //上传
            handleChange( file,fileList) {
                console.log(fileList)
                let arr=fileList.map((evidence)=>{
                    return evidence.name
                }).join('、')
                console.log(arr)
                this.filename=arr
            },
            View(){
                console.log(this.filename)
                if (this.filename==''){
                    this.$message.error('您没有上传文件哦，请上传文件后再来查看');
                }else {
                    this.dialogVisible=true
                }

            }
        },
    }
</script>

<style scoped>
    .supplementBox{
        padding: 30px;
        background-color: #fff;
    }
    .supplement>h4{
        width: 80px;
        color: #3e60f5;
        text-align: center;
        margin-bottom: 8px;
    }
    .supplement>p{
        width: 80px;
    }
    .contractNameBox{
        display: flex;
        margin: 20px 0px;
    }
    .contractNameBox>div{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
    }
    .contractNameBox p{
        width: 120px;
    }
    .particulars{
        background-color: #3b63f6;
        color: #fff;
    }
    .evidence{
        margin-top: 30px;
        border: 1px solid #3b63f6;
        width: 100px;
        text-align: center;
        border-radius: 5px;
    }
    .evidence>p{
        padding: 10px;
        color: #3b63f6;
    }
/*    证据*/
    .proofBox{
        background-color: #fff;
        padding: 30px;
        margin: 20px 0px;
        border: 1px solid #f3f2f8;
        border-radius: 5px;
    }
    /deep/.el-form-item__content{
        display: flex;
    }
    /deep/.el-input--small,
    /deep/.el-input__inner{
        width: 300px;
    }
    .inline{
        width: 60px;
        height: 32px;
        margin: 0px 15px;
    }
    /deep/.el-upload--text{
        width: 60px;
        height: 100%;
        border: 0px;
        background-color: #3b63f6;
        color: #fff;
    }
    .View{
        border-radius: 6px;
        width: 60px;
        height: 33px;
        background-color: #3b63f6;
        color: #fff;
    }
    .save{
        width: 120px;
        background-color: #3b63f6;
        color: #fff;
        height: 40px;
        border-radius: 5px;

    }
</style>
